<template>
  <el-card
    shadow="never"
    :body-style="{
      padding: '20px 15px',
    }"
  >
    <div v-if="!isEmpty">
      <Timeline>
        <TimelineItem
          v-for="(item, index) in trackingLogList"
          :key="index"
          v-bind="item"
        >
          <template #default="{ item }">
            <div class="pb-10" v-if="item.type == 'I'">
              <div class="desc_body_class d-flex" v-viewer="{ movable: true }">
                <div
                  v-for="(content, i) in item.content"
                  :key="i"
                  class="desc_body-item"
                >
                  <div class="desc_body-item__image">
                    <img
                      :src="content.originImageUrl"
                      style="width: 159px; height: 106px; object-fit: cover"
                      fit="cover"
                      @click="onPreview"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="pb-10" v-else-if="item.type == 'T'">
              <div
                v-for="(content, i) in item.content"
                :key="i"
                class="desc_body_class"
              >
                <div>
                  <div class="task_div mb-2">
                    <div class="executor">
                      <span class="label__key">
                        {{ $l('form_label_executor') || '执行人' }}：
                      </span>
                      <img
                        v-if="content.avatar"
                        :src="content.avatar"
                        class="description_avatar"
                      />
                      <span v-if="!content.avatar" class="description_avatar">
                        U
                      </span>
                      <span class="ml-5px"> {{ content.tskByName }}</span>
                    </div>
                    <div class="complete-time">
                      <span class="label__key">
                        {{ $l('form_label_tskEndDate') || '截止时间' }}：
                      </span>
                      <span> {{ content.tskEndDate }}</span>
                    </div>
                    <div class="complete-time">
                      <span class="label__key">
                        {{ $l('form_label_tskFinishTime') || '完成时间' }}：
                      </span>
                      <span> {{ content.tskFinishTime }} </span>
                    </div>
                    <div>
                      <span :class="'tag tag-' + content.tskStatus">{{
                        content.tskStatus == 'N'
                          ? $l('btn_tskStatus_N') || '待办'
                          : content.tskStatus == 'P'
                          ? $l('btn_tskStatus_P') || '进行中'
                          : content.tskStatus == 'U'
                          ? $l('btn_tskStatus_U') || '待确认'
                          : content.tskStatus == 'C'
                          ? $l('btn_tskStatus_C') || '已确认'
                          : content.tskStatus == 'Y'
                          ? $l('btn_tskStatus_Y') || '已完成'
                          : $l('btn_tskStatus_D') || '已取消'
                      }}</span>
                    </div>
                    <div>
                      <span class="tag tag-view" @click="openTaskInfo(content)"
                        >View</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pb-10" v-else-if="item.type == 'M'">
              <div class="desc_body_class">
                <span v-html="item.content"></span>
              </div>
            </div>
            <div class="pb-10" v-else-if="item.type == 'L'">
              <div class="desc_body_class d-flex">
                <div
                  v-for="(content, i) in item.content"
                  :key="i"
                  class="desc_body-item"
                >
                  <div class="d-flex">
                    <div>
                      <el-avatar
                        shape="square"
                        :src="content.custFileIcon"
                        :class="{ 'bg-transparent': content.custFileIcon }"
                      />
                    </div>
                    <div style="margin: 0px 20px 0px 14px; line-height: 18px">
                      <div>
                        <span
                          style="
                            font-size: 14px;
                            color: #007bff;
                            font-weight: 600;
                          "
                          >{{ content.fileName }}</span
                        >
                      </div>
                      <div
                        style="
                          font-size: 12px;
                          color: #6c757d;
                          font-weight: 600;
                        "
                      >
                        SIZE：{{ content.fileSize }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </TimelineItem>
      </Timeline>
    </div>
    <div v-else class="not-data__container">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </el-card>
</template>
<script>
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
import { request } from '@/api/service'
export default {
  components: { Timeline, TimelineItem },
  props: {
    devTrackingCode: { log: String, default: '' },
  },
  data() {
    return {
      trackingLogList: [],
      logList: [],
      logTypeOfJson: ['T', 'L', 'I'],
      fileIcons: {},
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isEmpty() {
      return !this.trackingLogList || !this.trackingLogList.length
    },
  },
  watch: {
    logList: {
      handler(e) {
        if (!e || !e.length) return
        this.getFileIcons()
      },
      immediate: true,
    },
  },

  methods: {
    getData() {
      if (!this.devTrackingCode) return
      this.loading = true
      this.$api
        .masterCustomerDevTrackingLogListApi({
          devTrackingCode: this.devTrackingCode,
        })
        .then((res) => {
          this.loading = false
          this.trackingLogList = res.body.data || []
          this.logList = res.body.data || []
        })
        .catch(() => {
          this.loading = false
        })
    },
    openTaskInfo({ tskInfoCode, tskInfoNo }) {
      this.$router.push({
        name: 'personal-taskCenter-detail',
        params: { code: tskInfoCode, pageType: 'detail' },
        query: { tskInfoNo },
      })
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
      this.trackingLogList = this.trackingLogList.map((m) => {
        if (this.logTypeOfJson.includes(m.devTrackingLogType) && m.logContent) {
          m.logContent = JSON.parse(m.logContent)
          if (
            m.devTrackingLogType === 'L' &&
            m.logContent &&
            m.logContent.length > 0
          ) {
            m.logContent = m.logContent.map((t) => {
              t.custFileIcon = this.getFileIcon(t.fileType)
              return t
            })
          }
        }
        m.type = m.devTrackingLogType
        m.title = m.logTitle
        m.time = m.logTime
        m.name = m.logByName
        m.content = m.logContent
        return m
      })
    },
    getFileIcon(fileType) {
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    onPreview(index) {
      const viewer = this.$el.querySelector('.desc_body_class').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.imageClass {
  border: 1px #bbbbbb dashed;
  border-radius: 50px;
  background-color: white;
  text-align: center;
  height: 30px;
  width: 30px;
  line-height: 24px;
}
.titleText {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
}
.descriptionText {
  font-size: 12px;
  color: #8f97ad;
}
.headImage {
  margin: 0 5px;
  width: 20px;
  height: 20px;
}
.desc_body_class {
  flex-wrap: wrap;
  border: 1px #bbbbbb dashed;
  padding: 13px 15px;
  margin-top: 10px;
  border-radius: 5px;
}
.pb-10 {
  padding-bottom: 10px;
}
.desc_body-item {
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.desc_body-item__image {
  background-color: rgba(244, 246, 249, 1);
  border-radius: 5px;
  padding: 5px;
}
.task_left_class {
  color: #8e8e8e;
  font-size: 14px;
  font-weight: 600;
}
.task_right_class {
  color: #303133;
  font-size: 14px;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.task_div {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  // padding: 0 15px;
  .executor {
    font-size: 14px;
    color: #303133;
    .description_avatar {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 50%;
      background-color: #cccccc;
      color: #fff;
      font-size: 14px;
      cursor: default;
      margin-left: auto;
    }
  }
  .complete-time {
    color: #303133;
    font-size: 14px;
  }
}
.tag {
  width: 100px;
  height: 30px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.tag-N {
  background-color: #efefef;
  color: #4f4f4f;
}
.tag-P {
  background-color: #e7f1fe;
  color: #307af9;
}
.tag-Y {
  background-color: #dfffea;
  color: #28a745;
}
.tag-view {
  width: 60px !important;
  height: 30px;
  background-color: #efefef;
  color: #4f4f4f;
  cursor: pointer;
}
.tag-view:hover {
  background-color: #e7f1fe;
  color: #307af9;
}
.tag-B {
  background-color: #e7f1fe;
  color: #307af9;
}
</style>
